// export default function PermissionManagement() {
//
//   return (
//       <p>مدیریت دسترسی</p>
//   );
// };

// import { useState } from "react";
// import DatePicker from "react-multi-date-picker";
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
//
// export default function PermissionManagement() {
//   const [date, setDate] = useState(null);
//
//   return (
//     <div>
//       <p>مدیریت دسترسی</p>
//
//       <DatePicker
//         calendar={persian}
//         locale={persian_fa}
//         value={date}
//         onChange={setDate}
//       />
//
//       {/* نمایش تاریخ شمسی انتخاب‌شده */}
//       <p>تاریخ انتخاب‌شده: {date?.format?.("YYYY/MM/DD")}</p>
//     </div>
//   );
// }

import { useState } from "react";
import ShamsiDatePicker from "../../components/Form/ShamsiDatePicker";
import {toPersianNumbers} from "../../utils/toPersianNumbers";

export default function TestPage() {
  const [formData, setFormData] = useState({
    birth_date_miladi: "",
    birth_date_shamsi: "",
  });

  return (
    <div className="p-4">
      <label className="block mb-2 font-medium">تاریخ تولد:</label>
      <ShamsiDatePicker
        value={formData.birth_date_miladi}
        onChange={({ miladi, shamsi }) =>
          setFormData({
            ...formData,
            birth_date_miladi: miladi,
            birth_date_shamsi: shamsi,
          })
        }
      />

      <div className="mt-4 p-3 bg-gray-100 rounded-md">
        <p>📅 تاریخ میلیادی برای بک: {formData.birth_date_miladi || "---"}</p>
        <p>📅 تاریخ شمسی برای نمایش: {toPersianNumbers(formData.birth_date_shamsi) || "---"}</p>
      </div>
    </div>
  );
}

